import { useDispatch } from 'react-redux';
import api from './axiosInstance.js';
import {
  setFonts,
  setFontsError,
  setFontsLoading,
  setUsers,
  setUsersError,
  setUsersLoading,
} from '../redux/adminSlice.js';

export const useFetchAdminData = () => {
  const dispatch = useDispatch();

  const fetchAllUsersEmail = async () => {
    try {
      dispatch(setUsersLoading(true));
      const response = await api.get(`/users`);
      const sortedData = response.data.sort((a, b) => a.name.localeCompare(b.name));
      dispatch(setUsers(sortedData));
    } catch (error) {
      dispatch(setUsersError(true));
    } finally {
      dispatch(setUsersLoading(false));
    }
  };

  const fetchAllFonts = async () => {
    try {
      dispatch(setFontsLoading(true));
      const response = await api.get(`/fonts`);
      const fonts = response.data.fonts;

      const md5hashCount = fonts.reduce((acc, font) => {
        acc[font.md5hash] = (acc[font.md5hash] || 0) + 1;
        return acc;
      }, {});

      const uniqueFonts = fonts.reduce((acc, font) => {
        if (!acc.some((f) => f.md5hash === font.md5hash)) {
          acc.push(font);
        }
        return acc;
      }, []);

      const sortedFonts = uniqueFonts.sort(
        (a, b) => md5hashCount[b.md5hash] - md5hashCount[a.md5hash]
      );
      dispatch(setFonts(sortedFonts));

      return sortedFonts;
    } catch (error) {
      dispatch(setFontsError(true));
    } finally {
      dispatch(setFontsLoading(false));
    }
  };

  return { fetchAllUsersEmail, fetchAllFonts };
};